import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import type { Episode } from "./types";

function formatDuration(seconds: number | null): string {
  if (seconds === null) return "";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

export function PodcastPage() {
  const [episodes, setEpisodes] = useState<Episode[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [playingId, setPlayingId] = useState<string | null>(null);

  useEffect(() => {
    api
      .get<{ episodes: Episode[] }>("/api/v1/podcast/episodes")
      .then((r) => setEpisodes(r.episodes.filter((e) => e.publishStatus === "published")))
      .catch(() => setError("Folgen konnten nicht geladen werden."));
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <section className="pw-card">
        <h1 style={{ margin: "0 0 0.3rem", fontSize: "1.35rem", fontWeight: 600 }}>Podcast</h1>
        <p style={{ margin: 0, fontSize: "0.85rem", color: "var(--pw-color-text-muted)" }}>
          Webplayer für Mitglieder. Den persönlichen RSS-Link für eure Podcast-App findet ihr im{" "}
          <a href="/account" style={{ color: "var(--pw-color-accent-strong)" }}>
            Konto
          </a>
          .
        </p>
      </section>

      {error && <div className="pw-alert pw-alert--error">{error}</div>}

      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        {episodes?.length === 0 && <p style={{ color: "var(--pw-color-text-muted)", fontSize: "0.9rem" }}>Noch keine veröffentlichten Folgen.</p>}
        {episodes?.map((ep) => (
          <div key={ep.id} className="pw-card" style={{ padding: "1rem" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
              {ep.coverAssetId && (
                <img
                  src={`/api/v1/podcast/episodes/${ep.id}/cover`}
                  alt=""
                  width={56}
                  height={56}
                  style={{ borderRadius: "var(--pw-radius-sm)", objectFit: "cover", flexShrink: 0 }}
                />
              )}
              <div style={{ flex: 1, minWidth: 0 }}>
                <span style={{ display: "block", fontWeight: 600, fontSize: "0.95rem" }}>{ep.title}</span>
                {ep.description && <span style={{ display: "block", fontSize: "0.8rem", color: "var(--pw-color-text-muted)" }}>{ep.description}</span>}
                {ep.durationSeconds !== null && <span style={{ fontSize: "0.75rem", color: "var(--pw-color-text-muted)" }}>{formatDuration(ep.durationSeconds)}</span>}
              </div>
              <button type="button" className="pw-button" onClick={() => setPlayingId(playingId === ep.id ? null : ep.id)}>
                {playingId === ep.id ? "Player schließen" : "Abspielen"}
              </button>
            </div>
            {playingId === ep.id && (
              <audio controls autoPlay style={{ width: "100%", marginTop: "0.8rem" }} src={`/api/v1/podcast/episodes/${ep.id}/audio`}>
                Dein Browser unterstützt kein Audio-Element.
              </audio>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
